export const fetchingData = (TYPE, state, action) => {
  switch (action.type) {
    case TYPE.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      }
    case TYPE.SUCCESS:
      return {
        ...state,
        loading: true,
        error: '',
        data: action.data.reduce((prev, cur) => ({
          ...prev,
          [cur.id]: cur
        }), {})
      }
    case TYPE.FAILURE:
      return {
        ...state,
        loading: true,
        error: action.error,
      }
    default:
      return state
  }
}

// inject lang key to initial state
export const initStateLang = (state, key) => {
  const removeOldKey = Object.keys(state).reduce((prev, cur) => (
    key.some(value => value === cur.toString()) ?
    prev :
    { ...prev,
      [cur]: state[cur]
    }
  ), {})
  return {
    ...removeOldKey,
    ...key.reduce((prev, cur) => ({
      th: {
        ...prev.th,
        [cur]: state[cur]
      },
      en: {
        ...prev.en,
        [cur]: state[cur]
      },
      zh: {
        ...prev.zh,
        [cur]: state[cur]
      }
    }), {})
  }
}
// update state lang
// [action.lang]: { data: action.data }


// WEBPACK FOOTER //
// ./src/utils/index.js